import React from "react";
import Arrow from "./Arrow";

const Marketing = () => {
  const generateArrows = (num) => {
    const arrows = [];
    for (let i = 0; i < num; i++) {
      const left = Math.random() * 100;
      const delay = Math.random() * 5;
      const size = 5;
      arrows.push(<Arrow key={i} left={left} delay={delay} size={size} />);
    }

    return arrows;
  };
  return (
    <section className="marketing-container" id="marketing">
      <div className="text-light d-flex justify-content-center pt-4">
        <h2 className="category-underline text-center">Marketing Technology</h2>
      </div>
      <div className="arrow-background">{generateArrows(27)}</div>

      <div className="gear-container">
        <img src="marketing-gears.png" alt="Marketing Gears" className="gear" />

        <div className="gear-box email-automation">
          <span className="gear-title">Email Automation:</span> <br />{" "}
          Personalized email campaigns that drive engagement.
        </div>
        <div className="gear-box crm-integration">
          <span className="gear-title">CRM Integration:</span>
          <br /> Unify your data with seamless platform connections.
        </div>
        <div className="gear-box workflow-optimization">
          <span className="gear-title">Workflow Optimization:</span>
          <br /> Streamline your marketing processes.
        </div>
        <div className="gear-box custom-solutions">
          <span className="gear-title">Custom Solutions:</span> <br />{" "}
          Innovative strategies tailored to your business needs.
        </div>
      </div>
    </section>
  );
};

export default Marketing;
